import { Component, OnInit, OnDestroy } from '@angular/core';
import { LoyaltySiteManagementService } from "./loyalty-site-management.service";
import { LoyaltySite } from "./loyalty-site";
import { Router } from "@angular/router";
import { Subscription } from "rxjs/Subscription";
import { LocalStorageService } from "angular-2-local-storage";
import { IMyDpOptions, IMyDateModel } from 'mydatepicker';
import { SearchTableState } from "../search-table-state";
import { Column } from "../column";
import { AlertService } from "../../../services/index";
import { ProgrammeService } from "../../../services/DataServices/programme.service";
import { PageStateService } from "../page-state.service";
import { BaseTableComponent } from "../base-table.component";
import * as FileSaver from "file-saver";
import { PermissionService } from "../../../services/SecurityServices/permission.service";

declare var jQuery: any;

@Component({
    template: require('./loyalty-site-management-table.html'),
    providers: [LoyaltySiteManagementService, LocalStorageService],
    styles: [require('../table.css')]
})

export class LoyaltySiteManagementTableComponent extends BaseTableComponent implements OnInit, OnDestroy {

    private loyaltySites = new Array<LoyaltySite>();
    private searchTableState: SearchTableState;
    private allLoyaltySites: Array<LoyaltySite> = [];
    private loyaltySite: LoyaltySite = null;
    private columns: Array<Column>;
    private busy: Subscription;
    private showFilter: boolean = false;
    private static lastRefreshed: string = 'loyalty-site-last-refreshed';
    private disableSites: boolean = false;
    private disableExportToExcel: boolean = false;
    private disableViewSite: boolean = false;
    private disablePostSite: boolean = false;
    private dateFormat: string = 'yyyy-mm-dd';
    private datePickerOptions: IMyDpOptions = {
        height: '30px',
        dateFormat: this.dateFormat
    };

    constructor(
        private loyaltySiteManagementService: LoyaltySiteManagementService,
        private router: Router,
        private alertService: AlertService,
        private programmeService: ProgrammeService,
        private pageStateService: PageStateService,
        private localStorageService: LocalStorageService,
        private permissionService: PermissionService
    ) {
        super(localStorageService, loyaltySiteManagementService.searchTableState);
        this.setColumns();
    }

    public goTo(value: number): void {
        if (value <= this.searchTableState.pageCount()) {
            this.searchTableState.pageChange(value);
            this.updateTable();
        }
    }

    ngOnInit() {
        this.setPermissions();
        this.searchTableState = this.loyaltySiteManagementService.searchTableState;
        this.searchTableState.currentPage = this.pageStateService.currentLoyaltySitePage;
        this.setPageSize('loyalty-site-page-size');
        this.blankPage();
        this.setLastRefreshed(LoyaltySiteManagementTableComponent.lastRefreshed);
        this.updateTable();
    }

    ngOnDestroy() {
        this.pageStateService.currentLoyaltySitePage = this.searchTableState.currentPage;
    }

    private setPermissions(): void {
        this.disableSites = !this.permissionService.userHasPermission('Site_DisableSite');
        this.disableExportToExcel = !this.permissionService.userHasPermission('Site_ExportExcel');
        this.disableViewSite = !this.permissionService.userHasPermission('View_Site');
        this.disablePostSite = !this.permissionService.userHasPermission('Site_PostSite');
    }

    private setColumns() {
        this.columns = new Array<Column>();
        this.columns.push(new Column('Site ID', 'SiteID'));
        this.columns.push(new Column('Location Name', 'SiteName'));
        this.columns.push(new Column('Username', 'UserName'));
        this.columns.push(new Column('Date Created', 'CreateDateUtc'));
        this.columns.push(new Column('Status', 'Status'));
    }

    private blankPage() {
        this.loyaltySites = new Array<LoyaltySite>();
        for (let i: number = 0; i < this.searchTableState.itemsPerPage; i++) {
            this.loyaltySites.push(new LoyaltySite());
        }
    }

    private disableLoyaltySite(e: boolean, loyaltySite: LoyaltySite) {
        loyaltySite.status = e;
        let self: LoyaltySiteManagementTableComponent = this;
        this.loyaltySiteManagementService.disableLoyaltySite(loyaltySite.LoyaltySiteId, loyaltySite.status).subscribe(() => {
        }, error => loyaltySite.status = false);
    }

    private exportExcel(): void {
        if (this.searchTableState.updating) {
            return;
        }
        this.searchTableState.updating = true;
        let self: LoyaltySiteManagementTableComponent = this;
        this.loyaltySiteManagementService.exportExcel().subscribe(blob => {
            self.searchTableState.updating = false;
            if (!blob) {
                return;
            }
            var fileName = 'Locations_' + this.searchTableState.lastRefreshed + '.xlsx';
            FileSaver.saveAs(blob, fileName);
            self.alertService.success('File generated successfully.');
        }, error => self.searchTableState.updating = false);
    }

    private filterTable(): void {
        if (this.searchTableState.fromDate && this.searchTableState.toDate && this.searchTableState.fromDate.getTime() > this.searchTableState.toDate.getTime()) {
            this.alertService.error('From Date cannot be more than To Date');
            return;
        }
        this.updateTable();
    }

    private updateTable(): void {
        if (this.searchTableState.updating) {
            return;
        }
        this.searchTableState.updating = true;
        let loyaltySiteVal = jQuery('.loyalty-site-input').val();
        if (loyaltySiteVal) {
            this.searchTableState.siteName = loyaltySiteVal;
        }
        let self: LoyaltySiteManagementTableComponent = this;
        this.busy = this.loyaltySiteManagementService.search().subscribe((message: Array<LoyaltySite>) => {
            self.loyaltySites = message;
            if (self.allLoyaltySites.length == 0) {
                self.programmeService.getLoyaltySites().subscribe(data => {
                    self.allLoyaltySites = self.loyaltySiteManagementService.dataToLoyaltySite(data);
                });
            }
            self.searchTableState.updating = false;
        }, error => self.searchTableState.updating = false);
    }

    private listFormatter(data: LoyaltySite): string {
        return data.SiteName;
    }

    private onClick(loyaltySite: LoyaltySite): void {
        if (!this.disableViewSite) {
            this.router.navigate(['admin/loyalty-site-management/loyalty-site', loyaltySite ? loyaltySite.LoyaltySiteId : 'new']);
        }
    }

    private refreshTable() {
        if (this.searchTableState.updating) {
            return;
        }
        this.updateLastRefreshed(LoyaltySiteManagementTableComponent.lastRefreshed);
        this.updateTable();
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/loyalty-site/loyalty-site-management-table.component.ts